import { createFileRoute } from '@tanstack/react-router'
import { InternAgreementsPage } from '@/pages/agreements/ui/InternAgreementsPage'

export const Route = createFileRoute('/my-agreements')({
  component: InternAgreementsPage,
})
